import { useEffect, useMemo, useState } from 'react';
import Link from './link.js';
import Header from './header.js';
import UptimeRobot from './uptimerobot.js';
import Package from '../../package.json';
import { getInitialLocale, persistLocale, t } from '../common/i18n.js';

function App() {
  const [locale, setLocale] = useState(() => getInitialLocale());

  useEffect(() => {
    const loader = document.getElementById('app-loading');
    if (loader) {
      const minDuration = 900;
      const start = Date.now();
      const hideLoader = () => {
        const elapsed = Date.now() - start;
        const delay = Math.max(minDuration - elapsed, 0);
        window.setTimeout(() => {
          loader.classList.add('is-hidden');
          window.setTimeout(() => {
            loader.remove();
          }, 300);
        }, delay);
      };

      hideLoader();
    }
  }, []);

  const handleLocaleChange = (event) => {
    const nextLocale = event.target.value;
    setLocale(nextLocale);
    persistLocale(nextLocale);
  };

  const apikeys = useMemo(() => {
    const { ApiKeys } = window.Config;
    if (Array.isArray(ApiKeys)) return ApiKeys;
    if (typeof ApiKeys === 'string') return [ApiKeys];
    return [];
  }, []);

  return (
    <>
      <Header locale={locale} />
      <div className='container'>
        {window.Config.Notification && <div id='notification'>{window.Config.Notification}</div>}
        <div id='uptime' style={window.Config.Notification ? { marginTop: 30 } : {}}>
          {apikeys.map((key) => (
            <UptimeRobot key={key} apikey={key} locale={locale} />
          ))}
        </div>
        <div id='footer'>
          <p>&copy; 2025 <Link to='https://wenlei.top/' text='wenlei.top'/></p>
          <p>
            {locale === 'zh' ? (
              <>在 <Link to='https://github.com/Andy17269/UptimeStatus-Next' text='Github'/> 上查看此项目</>
            ) : (
              <>View this project on <Link to='https://github.com/Andy17269/UptimeStatus-Next' text='Github'/></>
            )}
          </p>
          <p className='lang-select'>
            <label htmlFor='language-select'>{t(locale, 'languageLabel')}</label>
            <select id='language-select' value={locale} onChange={handleLocaleChange}>
              <option value='zh'>{t(locale, 'languageChinese')}</option>
              <option value='en'>{t(locale, 'languageEnglish')}</option>
            </select>
          </p>
          <p>v{Package.version}</p>
        </div>
      </div>
    </>
  );
}

export default App;
